/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { AssetLibraryUploadButtonComponent } from './asset-library-upload-button/asset-library-upload-button.component';
import { UppyDashboardComponent } from './uppy-dashboard/uppy-dashboard.component';
import { SVGIconModule } from '../svg-icon/svg-icon.module';
import { AeroDialogService } from '../../aero/aero-dialog/aero-dialog.service';
import { CanvaFormatDialogComponent } from './canva-format-dialog/canva-format-dialog.component';

@NgModule({
  declarations: [
    AssetLibraryUploadButtonComponent,
    UppyDashboardComponent,
    CanvaFormatDialogComponent,
  ],
  imports: [
    CommonModule,
    SVGIconModule,
    TranslocoModule,
    SvgIconComponent,
  ],
  exports: [
    UppyDashboardComponent,
  ],
  providers: [
    AeroDialogService,
  ],
})
export class AssetUploadsModule { }
